import { EmployeeResource, employeeResource } from '@witkac/kartamiejska-resources';
import { Employee, Profile, SessionStorage, StateString } from '@witkac/kartamiejska-shared';

import { EntityModule } from './entity.module';

/**
 * Moduł listy pracowników partnera
 *
 * @export
 * @class EmployeeModule
 * @extends {EntityModule<Employee, EmployeeResource>}
 */
export class EmployeeModule extends EntityModule<Employee, EmployeeResource> {
  constructor() {
    super(employeeResource);
    /**
     * Stan store
     *
     * @memberof ClientModule
     */
    this.state = {
      ...this.state,
      data: {
        profile: {
          id: undefined,
          firstName: undefined,
          lastName: undefined,
          email: undefined,
          userId: undefined,
          user: {
            userId: undefined,
            state: undefined
          }
        },
        login: undefined
      }
    };

    this.actions = {
      ...this.actions,
      /**
       * Pobiera listę pracowników danego partnera
       *
       * @param context context
       * @param id id profilu do którego jest przypisany partner
       */
      list: (context: any): Promise<void> => {
        const partnerId: number = parseInt(localStorage.getItem(SessionStorage.PARTNER_ID) as string, 10);
        return employeeResource
          .employeeList(partnerId)
          .then(list => context.commit('saveList', list.filter(employee => employee.state === StateString.ACTIVE)));
      },
      /**
       * Dodaje encję
       *
       * @param context context
       * @param data dane do wysłania do API
       */
      add: (context: any, data: { profile: Profile }): Promise<void> => {
        return this.resource.add(data).then(() => context.dispatch('list'));
      },
      /**
       * Aktualizuje profil pracownika
       *
       * @param context context
       * @param data dane do wysłania do API
       */
      update: (context: any, data: any) => {
        const userId = data.profile.userId;
        delete data.profile.userId;
        return this.resource.update(data.id, data).then(id => {
          data.profile.id = id;
          data.profile.userId = userId;
          context.commit('update', data.profile);
          context.commit('setEntity', data.profile);
        });
      }
    };
    this.mutations = {
      ...this.mutations,
      /**
       * Zapisuje pracownika do store
       *
       * @param localState stan lokalny
       * @param profile profil klienta
       */
      setEntity(localState: any, profile: any): void {
        Object.keys(localState.data.profile)
          .filter(key => profile[key] !== undefined)
          .forEach(key => (localState.data.profile[key] = profile[key]));
        if (profile.user) {
          localState.data.login = profile.user.login;
        }
      }
    };
  }
}

export default new EmployeeModule();
